import React, {BrowserRouter} from 'react-router-dom';
import {ApolloProvider} from '@apollo/client';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';

import ToastContainer from '@components/ToastContainer';

import client from './services/client';
import {store, persistor} from './store';
import Routes from './routes';

import './styles/_base.scss';

function App() {
  return (
    <ApolloProvider client={client}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
          <ToastContainer />
        </PersistGate>
      </Provider>
    </ApolloProvider>
  );
}

export default App;
